import { render, staticRenderFns } from "./Newteacher.vue?vue&type=template&id=54c94599&scoped=true&"
import script from "./Newteacher.vue?vue&type=script&lang=js&"
export * from "./Newteacher.vue?vue&type=script&lang=js&"
import style0 from "./Newteacher.vue?vue&type=style&index=0&id=54c94599&scoped=true&lang=css&"
import style1 from "./Newteacher.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c94599",
  null
  
)

export default component.exports